import React from 'react';
import { FaMobileAlt } from 'react-icons/fa';
import './BrandLoader.css';

/**
 * BrandLoader component for premium loading experience.
 * @param {string} message - Optional message to display below the loader.
 * @param {boolean} fullScreen - Whether to display as a full-screen overlay.
 */
const BrandLoader = ({ message = "Synchronizing Data...", fullScreen = false }) => {
    return (
        <div className={`brand-loader-container ${fullScreen ? 'full-screen' : ''}`}>
            <div className="loader-content">
                <div className="loader-portal">
                    <div className="portal-ring"></div>
                    <div className="portal-ring"></div>
                    <div className="portal-icon">
                        <FaMobileAlt />
                    </div>
                </div>

                <div className="loader-text">
                    <span className="shimmer-text">{message}</span>
                    <div className="loading-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandLoader;
